import React from "react";
import clsx from "clsx";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
  Tooltip
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { logout } from "../../../actions/accountActions";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useTheme } from "@material-ui/styles";
import { THEMES } from "../../../constants";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import NightsStayIcon from "@material-ui/icons/NightsStay";
import useSettings from "../../../hooks/useSettings";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer - 10,

    backgroundColor: theme.palette.background.dark
  },
  fab: {
    color: theme.palette.primary.dark
  },
  toolbar: {
    minHeight: 64
  }
}));

function TopBar({ className, ...rest }) {
  const classes = useStyles();
  const history = useHistory();
  const { saveSettings } = useSettings();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  const handleLogout = async () => {
    try {
      await dispatch(logout());
    } catch (error) {
      enqueueSnackbar("Unable to logout", {
        variant: "error"
      });
    } finally {
      history.push("/");
    }
  };

  return (
    <AppBar elevation={0} className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Box ml={2} flexGrow={1} />
        <Box ml={2}>
          <Tooltip title={theme.name === THEMES.DARK ? "День" : "Ночь"}>
            <IconButton
              color="inherit"
              onClick={() => {
                saveSettings(
                  theme.name === THEMES.DARK
                    ? { theme: THEMES.LIGHT }
                    : { theme: THEMES.DARK }
                );
              }}
            >
              <SvgIcon fontSize="small">
                {theme.name === THEMES.DARK ? (
                  <WbSunnyIcon className={classes.fab} />
                ) : (
                  <NightsStayIcon className={classes.fab} />
                )}
              </SvgIcon>
            </IconButton>
          </Tooltip>
        </Box>
        <Box ml={2}>
          <Tooltip title="Выйти">
            <IconButton color="inherit" onClick={handleLogout}>
              <SvgIcon fontSize="small">
                <ExitToAppIcon className={classes.fab} />
              </SvgIcon>
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {};

export default TopBar;
